import React from 'react'
import Price from "../Misc/Price";
import InlineTip from "../Misc/InlineTip";

export default function StepOption({
  option,
  layout,
  settingId,
  checked,
  setChecked
}) {
  const htmlId = 'option' + settingId + '_' + option.id
  const disabled = false // TODO: Implement!

  return (
    <>
      <input
        id={htmlId}
        type='checkbox'
        name={'option' + settingId}
        value={option.id}
        checked={checked}
        onChange={(e) => setChecked(option.id)}
        disabled={disabled}
      />
      <label
        htmlFor={htmlId}
        className='option'
        data-layout={layout}
        data-disabled={disabled}
      >
        {typeof option.imageUrl === 'string' && option.imageUrl.length >= 0 && (
          <img className='image' src={option.imageUrl} alt=''/>
        )}

        <div>{option.title?.length > 0 ? option.title : option.name}</div>

        <div className='description'>
          <div>
            <span>+</span>
            <Price price={option.price}/>
          </div>

          {option?.descriptionTitle?.length > 0 && option?.description?.length > 0 ? (
            <InlineTip button='Ok' label={option.descriptionTitle} content={option.description}/>
          ) : null}
        </div>
      </label>
    </>
  )
}
